import { Col } from '@vertem-core/vertice-ds';
import VertCardProductContainer from 'components/VertCardProductContainer/VertCardProductContainer';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isObjectEmpty } from 'Utils';
import { addDimensionsShowcase } from 'Shared/dataLayer/dataLayer';
import { stringToSlug } from 'Utils/stringToSlug';

const CategoryItems = ({ items }) => {
  const [productsLoaded, setProductsLoaded] = useState(false);
  const availabilityItems = useSelector(({ Availability }) => Availability);
  const showcaseState = items;

  const readShowcaseProductsAvaiability = () => {
    setTimeout(() => {
      const everyAvaiability = showcaseState.every(({ sku }) => {
        return availabilityItems[sku];
      });
      setProductsLoaded(everyAvaiability);
    }, 2500);
  };

  useEffect(() => {
    if (
      !isObjectEmpty(availabilityItems) &&
      showcaseState &&
      showcaseState.length > 0
    ) {
      readShowcaseProductsAvaiability();
    }
  }, [availabilityItems, showcaseState]);

  useEffect(() => {
    if (productsLoaded) {
      const productInShowcase = showcaseState;
      const arrayAvailability = productInShowcase
        .map(({ sku }) => {
          if (availabilityItems[sku]) {
            return { sku: sku, ...availabilityItems[sku] };
          } else {
            return null;
          }
        })
        .filter((obj) => obj !== null);

      addDimensionsShowcase(
        productInShowcase,
        arrayAvailability,
        stringToSlug('search')
      );
    }
  }, [productsLoaded]);

  return (
    <>
      {(() => {
        if (!items || items.length === 0) return null;
        return items.map((item) => (
          <Col
            key={item.sku}
            xs={12}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            spacing="extra-small"
          >
            <VertCardProductContainer
              cardProduct={{ ...item, showcaseName: 'search' }}
            />
          </Col>
        ));
      })()}
    </>
  );
};

CategoryItems.propTypes = {
  items: PropTypes.array,
};

export default CategoryItems;
